import { motion } from "framer-motion";
import React from "react";
import { useForm } from "react-hook-form";
import image from "../../Resource/image/projects/email2.png";

export default function Contact() {
  const {
    register,
    trigger,
    formState: { errors },
  } = useForm();

  const onSubmit = async (e) => {
    const isvalid = await trigger();

    if (!isvalid) {
      e.preventDefault();
    }
  };

  return (
    <section id="contact" className="pt-20 pb-10">
      <motion.div
        className="text-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ delay: 0.4, duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, y: -50 },
          visible: { opacity: 1, y: 0 },
        }}
      >
        <div>
          <p className="font-lato font-semibold text-2xl md:text-3xl  ">
            <span className="text-red">CONTACT ME</span> TO GET STARTED
          </p>
        </div>
      </motion.div>

      <div className="md:flex md:justify-between gap-16 mt-20">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ delay: 0.6, duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, y: -50 },
            visible: { opacity: 1, y: 0 },
          }}
        >
          <div className="flex items-center justify-center  basis-3/5  mt-10">
            <img
              className="hover:filter  hover:saturate-200 transition duration-500 z-10 w-full 
                max-w-[200px] md:max-w-[250px] "
              src={image}
              alt="fullstackimage"
            />
          </div>
        </motion.div>
        <motion.div
          className="basis-1/2 mt-10 md:mt-0"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ delay: 0.6, duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, y: -50 },
            visible: { opacity: 1, y: 0 },
          }}
        >
          <form
            target="_blank"
            onSubmit={onSubmit}
            method="POST"
            action="https://formsubmit.co/c9e1f1a849eae426afa92d374a1f7bd1"
            className="flex flex-col items-center justify-center"
          >
            <input
              type="text"
              className="w-full bg-white placeholder-opaque-black p-3  text-black rounded-[5px]  outline-red"
              placeholder="NAME"
              {...register("name", {
                required: true,
                maxLength: 100,
              })}
            />

            {errors.name && (
              <p className="text-rose-700 mt-1">
                {errors.name.type === "required" && "This field is required."}
                {errors.name.type === "maxLength" && "Max length is 100 char."}
              </p>
            )}

            <input
              type="email"
              className="w-full bg-white placeholder-opaque-black p-3 mt-3 rounded-[5px] outline-red  text-black"
              placeholder="EMAIL"
              {...register("email", {
                required: true,
                pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
              })}
            />

            {errors.email && (
              <p className="text-rose-700 mt-1">
                {errors.email.type === "required" && "This field is required."}
                {errors.email.type === "pattern" && "Invalid email address."}
              </p>
            )}
            <textarea
              rows="4"
              type="email"
              className="w-full bg-white placeholder-opaque-black p-3 mt-3  rounded-[5px] outline-red text-black"
              placeholder="MESSAGE"
              {...register("message", {
                required: true,
                maxLength: 2000,
              })}
            />

            {errors.message && (
              <p className="text-rose-700 mt-1">
                {errors.message.type === "required" &&
                  "This field is required."}
                {errors.message.type === "maxLength" &&
                  "Max length is 2000 char"}
              </p>
            )}
            <button
              type="submit"
              className="py-2 px-3 mt-3 self-end font-semibold border-2 border-red text-red rounded-[5px] hover:text-white transition duration-500"
            >
              Send Message
            </button>
          </form>
        </motion.div>
      </div>
    </section>
  );
}
